import React, { useEffect, useState } from 'react' 
import { Link } from 'react-router-dom'

import BackToHome from '../../components/back-to-home'

import bg1 from '../../assets/images/comingsoon.jpg'

export default function PageComingsoon() {
    let [days, setDays] = useState(0);
    let [hours, setHours] = useState(0);
    let [minutes, setMinutes] = useState(0);
    let [seconds, setSeconds] = useState(0);

    let deadline = "September, 13, 2024";
  
    let getTime = () => {
      let time = Date.parse(deadline) - Date.now();
  
      setDays(Math.floor(time / (1000 * 60 * 60 * 24)));
      setHours(Math.floor((time / (1000 * 60 * 60)) % 24));
      setMinutes(Math.floor((time / 1000 / 60) % 60));
      setSeconds(Math.floor((time / 1000) % 60));
    };
  
    useEffect(() => {
      let interval = setInterval(() => getTime(deadline), 1000);
  
      return () => clearInterval(interval);
    }, []);
  return (
    <>
    <BackToHome/>
    <section className="bg-special d-flex align-items-center" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
        <div className="bg-overlay"></div>
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-8 col-md-12 text-center">
                    <Link to="#" className="text-white title-dark logo">Leaping<span className="text-primary">.</span></Link>
                    <div className="text-uppercase display-2 fw-bold text-white title-dark mt-2 mb-4 coming-soon">Coming soon</div>
                    <p className="text-white title-dark para-desc mx-auto">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                </div>
            </div>

            <div className="row">
                <div className="col-md-12 text-center">
                    <div id="countdown">
                        <ul className="count-down list-unstyled">
                            <li id="days" className="count-number list-inline-item m-2">{days}<p className='count-head'>Days</p></li>
                            <li id="hours" className="count-number list-inline-item m-2">{hours}<p className='count-head'>Hours</p></li>
                            <li id="mins" className="count-number list-inline-item m-2">{minutes}<p className='count-head'>Mins</p></li>
                            <li id="secs" className="count-number list-inline-item m-2">{seconds}<p className='count-head'>Secs</p></li>
                            <li id="end" className="h1"></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="row mt-4 pt-2">
                <div className="col-12 text-center">
                    <div className="subcribe-form">
                        <form>
                            <input name="email" id="email" type="email" className="rounded-pill" required="" placeholder="Your email :"/>
                            <button type="submit" className="btn btn-primary rounded-pill">Subscribe</button>
                        </form>
                    </div>
                </div>
            </div>
        </div> 
    </section>
    </>
  )
}
